import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 02F82A66-CEB3-4F54-825A-811342975170
 * name upload-outline
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/upload-outline.svg
 * tags
 */
export const UploadOutlineIcon = createSvgIcon(<><path d="M9,10V16H15V10H19L12,3L5,10H9M12,5.8L14.2,8H13V14H11V8H9.8L12,5.8M19,18H5V20H19V18Z" /></>, 'UploadOutlineIcon');
export default UploadOutlineIcon